/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'lavish',
    quality: 0,
    perception: -2,
    mana: -1,
    dodgeChance: -1.5
}